module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "additional-service-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-services",
      "to": {
        name: 'AdditionalServices'
      },
      "md-label": "Список услуг"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-services-prices",
      "to": {
        name: 'AdditionalServicesPrices'
      },
      "md-label": "Список цен"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3952f9c1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/additional_services/AdditionalServicesMenu.vue
// module id = 1111
// module chunks = 0